document.addEventListener('DOMContentLoaded', function () {
  // Function to find color option position dynamically
  function findColorOptionPosition(product) {
    for (let i = 0; i < product.options.length; i++) {
      const optionName = product.options[i].toLowerCase().trim();
      if (optionName === 'color' || optionName === 'colour') {
        return i;
      }
    }
    return 0; // Default to first option if no color found
  }

  const productLinks = document.querySelectorAll('.product-root__link');
  for (const productLink of productLinks) {
    const variantSelectorsPerColor = productLink.querySelectorAll('.radios--main');
    for (const variantSelectorPerColor of variantSelectorsPerColor) {
      variantSelectorPerColor.addEventListener('click', function () {
        const swatch = this.querySelector('input');
        const swatchColor = swatch.value;
        const anchorTag = swatch.closest('.product-root__link');
        anchorTag.setAttribute('data-var-color', swatchColor);
        const productLink = anchorTag.getAttribute('href') + '.json';

        swatch.checked = true;
        fetch(productLink)
          .then((response) => response.json())
          .then((data) => {
            const colorOptionPosition = findColorOptionPosition(data.product);
            const variant = data.product.variants.find((variant) => {
              const variantColor = variant.options[colorOptionPosition];
              return variantColor && variantColor.toLowerCase() === swatchColor.toLowerCase();
            });

            const productImages = data.product.images;
            let targetImg = productImages.find((productImg) => productImg.id == variant.image_id);
            if (!targetImg) targetImg = data.product.image;

            const imgs = anchorTag.querySelectorAll('.product--image-wrapper img');

            imgs.forEach((img) => {
              img.src = targetImg.src;
              img.dataset.src = targetImg.src;
              img.removeAttribute('srcset');
            });

            // setNewSizes(anchorTag, swatch);
          });
      });
    }
  }
});
